import marqueeContent from '@content/marquee.yaml'
import type { MarqueeContent } from '@/types/content'

const content = marqueeContent as unknown as MarqueeContent

export function MarqueeBand() {
  return (
    <div className="mq-band">
      <div className="mq-track">
        {[...content.items, ...content.items].map((item, i) => (
          <span key={i}>
            <span className="mq-item">{item}</span>
            <span className="mq-sep">{content.separator}</span>
          </span>
        ))}
      </div>
    </div>
  )
}
